import { DiscountTypeKey } from '~/constants/discountType';
import { useConfiguration } from '~/context/common/StaticContext';

type OwnProps = {
  amount: number;
  expirationDateTime: string;
  type: string;
}[];

export default function useGetCkPromoFromDiscounts(discounts: OwnProps): {
  shouldShowCkPromo: boolean;
  creditKarmaPromoAmount: number;
  expirationDate: string;
} {
  const { showCkPromo = false } = useConfiguration();
  const ckDiscount = discounts?.find(
    discount => discount?.type === DiscountTypeKey.CreditKarmaDiscount
  );
  const ckDiscountAmount = ckDiscount?.amount ?? 0;
  const shouldShowCkPromo = showCkPromo && Boolean(ckDiscountAmount);

  return {
    shouldShowCkPromo,
    creditKarmaPromoAmount: shouldShowCkPromo ? ckDiscountAmount : 0,
    expirationDate: ckDiscount?.expirationDateTime ?? ''
  };
}
